import { types } from '@commercebear/portal-api';

const bedBathAndBeyondChannels = new Set([
  types.channel.BED_BATH_AND_BEYOND_VENDOR_CA,
  types.channel.BED_BATH_AND_BEYOND_VENDOR_US,
]);

const overstockChannels = new Set([
  types.channel.OVERSTOCK_VENDOR_CA,
  types.channel.OVERSTOCK_VENDOR_US,
]);

function displayChannel(channel) {
  return (overstockChannels.has(channel) ? channel.replace('Overstock', 'Bed Bath & Beyond') : channel);
}

function reverseDisplayChannel(channel) {
  return (bedBathAndBeyondChannels.has(channel) ? channel.replace('Bed Bath & Beyond', 'Overstock') : channel);
}

export {
  displayChannel,
  reverseDisplayChannel,
};
